import type { ComponentStyleConfig } from '@chakra-ui/react';
import { inputAnatomy as parts } from '@chakra-ui/anatomy';

const inputStyle: ComponentStyleConfig = {
  parts: parts.keys,
  variants: {
    mbe: {
      field: {
        fontWeight: 'light',
        fontSize: 'medium',
        border: '1px',
        borderColor: '#ccc',
        borderRadius: 'none',
        bg: 'inherit',
        height: 14,
        _placeholder: { fontStyle: 'italic', color: '#060504', fontSize: 'medium' },
        _active: {
          fontStyle: 'normal',
        },
        _focus: {
          fontStyle: 'normal',
          borderColor: 'brand.black',
          _placeholder: { fontStyle: 'normal', color: '#ccc' },
        },
        _readOnly: {
          boxShadow: 'none !important',
          userSelect: 'all',
        },
        _disabled: {
          opacity: 0.4,
          cursor: 'not-allowed',
        },
        _invalid: {
          borderColor: '#ff0000',
          color: '#ff0000',
        },
      },
    },
  },
  defaultProps: {
    variant: 'mbe',
  },
};

export default inputStyle;
